export const INCOME_VALUE_LIST = [
  {
    id: '20',
    value: '1',
  },
  {
    id: '25',
    value: '2',
  },
  {
    id: '30',
    value: '3',
  },
  {
    id: '35',
    value: '4',
  },
  {
    id: '40',
    value: '5',
  },
  {
    id: '45',
    value: '6',
  },
  {
    id: '50',
    value: '7',
  },
  {
    id: '55',
    value: '8',
  },
  {
    id: '60',
    value: '9',
  },
  {
    id: '65',
    value: '10',
  },
  {
    id: '70',
    value: '11',
  },
  {
    id: '80',
    value: '12',
  },
  {
    id: '90',
    value: '13',
  },
  {
    id: '100',
    value: '14',
  },
] as const;
